import { Typography, CircularProgress } from '@mui/material';
import { useState, useEffect } from 'react';
import { downloadData } from 'aws-amplify/storage';

export function PrivacyPolicy() {
  const [htmlContent, setHtmlContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchHtmlContent = async () => {
      try {
        const downloadResult = await downloadData({
          key: 'privacyPolicy.html' // S3にこちらのファイル名でアップロードしてください
        }).result;
        const text = await downloadResult.body.text();
        setHtmlContent(text);
      } catch (error) {
        setError('プライバシーポリシーの取得に失敗しました。');
      } finally {
        setLoading(false); // ローディング終了
      }
    };

    fetchHtmlContent();
  }, []);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <Typography
      fontSize={14}
      sx={{
        textAlign: 'left',
        maxWidth: '100%',
        '& table': {
          width: '100%',
          tableLayout: 'fixed'
        },
        '& td': {
          padding: '6px',
          wordWrap: 'break-word'
        },
        '& h1': {
          textAlign: 'center',
          fontSize: '18px',
          marginBottom: '12px'
        }
      }}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}
